export const sporitelnaBankAccountFrag = `
    id
    nameI18N
    currency
    ownerNames
    identification {
        iban
    }
`;
